import Box from '@redbubble/design-system/src/Box';
import Stack from '@redbubble/design-system/src/Stack';
import Text from '@redbubble/design-system/src/Text';
import { FormattedNumber } from '@redbubble/next/intl';
import React from 'react';
import styles from './Price.module.scss';

export interface PriceProps {
  total: number;
  undiscountedTotal: number;
  currency: string;
  loading: boolean;
}

const getPriceStyle = (loading: boolean, showUndiscountedTotal: boolean) => {
  if (loading) {
    return showUndiscountedTotal ? styles.discountedLoading : styles.loading;
  }

  return showUndiscountedTotal ? styles.discounted : '';
};

export const Price = ({
  total,
  undiscountedTotal,
  currency,
  loading,
}: PriceProps) => {
  if (!total) {
    return null;
  }

  const showUndiscountedTotal = undiscountedTotal > total;

  return (
    <Box className={styles.price} display="flex" justifyContent="center">
      <Stack>
        {showUndiscountedTotal && undiscountedTotal && (
          <Text muted data-testid="line-item-undiscounted-price">
            <del>
              <FormattedNumber
                value={undiscountedTotal}
                style="currency"
                currency={currency}
              />
            </del>
          </Text>
        )}

        <Text
          type="display5"
          className={getPriceStyle(loading, showUndiscountedTotal)}
          data-testid="line-item-total-price"
        >
          <FormattedNumber value={total} style="currency" currency={currency} />
        </Text>
      </Stack>
    </Box>
  );
};
